import '../../css/loader.css';

const BarLoader = () => <div className='loader'>Loading...</div>;

export default BarLoader;